import {useQuery} from 'react-query'
import {UserEditModalForm} from './UserEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getUserById, getUserEditModalData} from '../core/_requests'

type Props = {
  userType: string
  customerCode: number
}

const UserEditModalFormWrapper: React.FC<Props> = ({userType, customerCode}) => {
  const {itemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)

  const {
    isLoading,
    data: editData,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-user-edit-${userType}-${itemIdForUpdate}`,
    async () => {
      if (!itemIdForUpdate) return undefined
      try {
        if (getUserEditModalData) {
          const res = await getUserEditModalData(itemIdForUpdate, userType)
          if (res) return res
        }
      } catch (err) {
        console.warn('Falling back to getUserById:', err)
      }
      const fallbackUser = await getUserById(itemIdForUpdate)
      return fallbackUser ? {user: fallbackUser} : undefined
    },
    {cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false, enabled: enabledQuery}
  )

  if (!itemIdForUpdate) {
    return (
      <UserEditModalForm
        customerCode={customerCode}
        userType={userType}
        isUserLoading={isLoading}
        user={{code: undefined}}
      />
    )
  }

  if (!isLoading && !error && editData) {
    const editPayload = editData as any
    const userData = editPayload.user ?? editPayload
    const lookups = editPayload.lookups
    return (
      <UserEditModalForm
        userType={userType}
        isUserLoading={isLoading}
        user={userData}
        customerCode={customerCode}
        editLookups={lookups}
      />
    )
  }

  return null
}

export {UserEditModalFormWrapper}
